import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';

const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [pf, setPF] = useState("");
    const [isg, setISG] = useState("");
    const [purchaseRate, setPurchaseRate] = useState("0");
    const [mrp, setMRP] = useState("0");
    const [hsncode, setHSNCode] = useState("");
    const [gstRate, setGSTRate] = useState("0");
    const [discountPercentage, setDiscountPercentage] = useState("0");
    const [isExcluding, setIsExcluding] = useState(false);

    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedPGCategory, setSelectedPGCategory] = useState("");
    const [selectedItemGroup, setSelectedItemGroup] = useState("");

    const [dropdownCategoryOptions, setDropdownCategoryOptions] = useState([]);
    const [dropdownPGCategoryOptions, setDropdownPGCategoryOptions] = useState([]);
    const [dropdownItemGroupOptions, setDropdownItemGroupOptions] = useState([]);

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const clearForm = () => {
        setName("");
        setCode("");
        setPF("");
        setISG("");
        setPurchaseRate("");
        setMRP("");
        setHSNCode("");
        setGSTRate("");
        setDiscountPercentage("");
        setIsExcluding(false);

        setSelectedCategory("");
        setSelectedPGCategory("");
        setSelectedItemGroup("");
    };

    useEffect(() => {
        fetchDropdownCategoryOptions();
        fetchDropdownPGCategoryOptions();
        fetchDropdownItemGroupOptions();
    }, []);

    const fetchDropdownCategoryOptions = () => {
        fetchData('ItemApi', `/Category/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCategoryOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Category dropdown options:', error);
            });
    };

    const fetchDropdownPGCategoryOptions = () => {
        fetchData('ItemApi', `/PGCategory/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownPGCategoryOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Pg Category dropdown options:', error);
            });
    };

    const fetchDropdownItemGroupOptions = () => {
        fetchData('ItemApi', `/ItemGroup/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownItemGroupOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Pg Category dropdown options:', error);
            });
    };

    const submitData = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        if (!name) { // Check if the category is selected
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Code: code,
            Name: name,
            PF: pf,
            ISG: isg,
            PurchaseRate: purchaseRate,
            MRP: mrp,
            HSNCode: hsncode,
            GSTRate: gstRate,
            DiscountPercentage: discountPercentage,
            IsExcluding: isExcluding,
            CategoryId: selectedCategory,
            PGCategoryId: selectedPGCategory,
            ItemGroupId: selectedItemGroup,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('ItemApi', CreateData, token)
            .then((response) => {
                console.log('Item Created success:', response);
                setSuccessMessage("Item Created successfully!");
                setErrorMessage("");
                history.push('/ItemIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Group Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Create</h6>

                        <Button
                            
                            style={{ marginLeft: '8px',color: 'darkgreen', fontWeight: 'bolder' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}

                        </Button>


                        <Button
                           
                            component={Link}
                            to="/ItemIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' ,color:'brown',fontWeight: 'bolder'}}
                        >
                           <ReplyAllIcon  style={{ marginLeft: '8px' ,color:'brown', fontWeight: 'bolder'}}/> BACK TO LIST
                        </Button>

                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Item Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Item Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                type="text"
                                placeholder="Enter Code"
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Category
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                className={`custom-select ${selectedCategory ? 'fade-in' : 'fade-in'}`}
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                            >
                                <option value="">Select Category</option>
                                {dropdownCategoryOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                PG Category
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                className={`custom-select ${selectedPGCategory ? 'fade-in' : 'fade-in'}`}
                                value={selectedPGCategory}
                                onChange={(e) => setSelectedPGCategory(e.target.value)}
                            >
                                <option value="">Select PG Category</option>
                                {dropdownPGCategoryOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Item Group
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                className={`custom-select ${selectedItemGroup ? 'fade-in' : 'fade-in'}`}
                                value={selectedItemGroup}
                                onChange={(e) => setSelectedItemGroup(e.target.value)}
                            >
                                <option value="">Select Item Group</option>
                                {dropdownItemGroupOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                PF
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={pf}
                                onChange={(e) => setPF(e.target.value)}
                                type="text"
                                placeholder="Enter PF"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                ISG
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={isg}
                                onChange={(e) => setISG(e.target.value)}
                                type="text"
                                placeholder="Enter ISG"
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Purchase Rate
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={purchaseRate}
                                onChange={(e) => setPurchaseRate(e.target.value)}
                                type="text"
                                placeholder="Enter Purchase Rate"
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                MRP
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={mrp}
                                onChange={(e) => setMRP(e.target.value)}
                                type="text"
                                placeholder="Enter MRP"
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount %
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={discountPercentage}
                                onChange={(e) => setDiscountPercentage(e.target.value)}
                                type="text"
                                placeholder="Enter Discount %"
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                GST Rate
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={gstRate}
                                onChange={(e) => setGSTRate(e.target.value)}
                                type="text"
                                placeholder="Enter GST Rate"
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                HSN Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={hsncode}
                                onChange={(e) => setHSNCode(e.target.value)}
                                type="text"
                                placeholder="Enter HSN Code"
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="flex items-center">
                                <input
                                    type="checkbox"
                                    checked={isExcluding}
                                    onChange={(e) => setIsExcluding(e.target.checked)}
                                    className="mr-2 h-4 w-4"
                                />
                                <span className="uppercase tracking-wide text-black text-xs font-bold">
                                    Is Excluding
                                </span>
                            </label>
                        </div>
                    </div>

                </form>
            </div >
        </Fragment >
    );
};

export default ItemCreate;
